import React from 'react';
import Hero from './components/administration/Hero';
import Main from './components/administration/Main';
import ImportantLinksSlider from './components/Home/ImportantLinksSlider';

const Administration = () => {
    return (
        <div>
            <Hero />
            <Main />
            <ImportantLinksSlider />
        </div>
    )
}

export default Administration;